



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'Logo',
    components: {}
})
export default class Logo extends Vue {
    @Prop({ type: String, default: () => 'menu' }) public type: any;

    public jump() {
        this.$router.push({
            name: 'Home'
        });
    }

    private created() {
        this.init();
    }

    private init() {
        const { name } = this.$route;
        if (name === 'Home') {
            // this.$emit('update:type', 'footer');
        } else {
            this.$emit('update:type', 'menu');
        }
    }

    @Watch('$route')
    private change() {
        this.init();
    }

}
